import clsx from "clsx";
import React, { useId } from "react";
import { forwardRef } from "react";
import { FieldLabel } from "~/components/Forms";
import { MdAlternateEmail } from "react-icons/md";

export const EmailField = forwardRef<
    HTMLInputElement,
    Omit<React.ComponentPropsWithoutRef<"input">, "id"> & {
    label?: string;
    labelClassName?: string;
    inputClassName?: string;
    error?: any;
    note?: string;
    noteClassName?: string;
    light?: boolean;
}
>((
    { label, className, labelClassName, inputClassName, error, note, noteClassName, light, ...props },
    ref
) => {
    const id = useId();

    return (
        <div className={className}>
            {label && (
                <FieldLabel id={id} className={labelClassName} required={!!props.required}>
                    {label}
                </FieldLabel>
            )}
            <div className="relative">
            <span
                className={clsx(
                    "absolute inset-y-0 left-0 w-12 flex items-center justify-center rounded-l-md focus:outline-hidden",
                    error
                        ? "bg-rose-300 text-rose-700"
                        : (light
                            ? "bg-zinc-200 text-zinc-500"
                            : "bg-zinc-100 text-zinc-300")
                )}>
              <MdAlternateEmail size="22" />
            </span>
                <input
                    id={id}
                    ref={ref}
                    type="text"
                    aria-label="email"
                    aria-invalid={!!error}
                    className={clsx("field", error && "field-error", "pl-16 pr-3", inputClassName)}
                    {...props}
                />
            </div>
            {note && <div className={clsx("field-note", noteClassName)}>{note}</div>}
            {error && <div className="field-error-text">{error}</div>}
        </div>
    );
});

EmailField.displayName = "EmailField";
